// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';

// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
import * as colors from '@atlaskit/theme/colors';
var NOTIFICATION_SIZE = 8;
var SPACE_FROM_EDGE = "var(--ds-space-100, 8px)";

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var resizableMediaMigrationNotificationStyle = css({
  position: 'absolute',
  top: SPACE_FROM_EDGE,
  right: "calc(".concat("var(--ds-space-150, 12px)", " + ", SPACE_FROM_EDGE, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  backgroundColor: "var(--ds-background-warning-bold, ".concat(colors.Y300, ")"),
  borderRadius: "var(--ds-border-radius-circle, 50%)",
  width: "".concat(NOTIFICATION_SIZE, "px"),
  height: "".concat(NOTIFICATION_SIZE, "px"),
  pointerEvents: 'none'
});